export default __webpack_public_path__ + "static/media/IMG9.3677c2c6.png";